import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nutriscan_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolveImage = (url, size = 200) => {
  if (!url) return "";
  let u = url;
  // Open Food Facts отдаёт тяжёлые полноразмерные фото — заменяем на лёгкую миниатюру
  if (u.includes("openfoodfacts.org")) {
    u = u.replace(/\.(?:100|200|400|full)\.jpg(\?.*)?$/i, `.${size}.jpg$1`);
  }
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};
